export default __webpack_public_path__ + "static/media/basicCircle.e6ad6a4c.svg";